module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--square-grid",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8",
    style: (_vm.cubeStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9",
    style: (_vm.cubeStyles)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9229583c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/SquareGrid.vue
// module id = 945
// module chunks = 170